import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { UserStatusResponse } from "../../../definitions/user-status-response";
import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { VendorUsersState } from "../../models/mp-admin/vendor-stats-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AdminVendorUsersEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.vendorUsers.get),
			withLatestFrom(this.store.select(MpAdminSelectors.vendorUsers)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.vendorUsers.getSuccess(state))
					: of(MpAdminActions.vendorUsers.getApi({ params: action.params }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.vendorUsers.getApi),
			withLatestFrom(this.store.select(MpAdminSelectors.vendorUsers)),
			switchMap(([action, state]) =>
				this.mpAdminService.vendorUsers(action.params.id).pipe(
					map((users) => {
						return MpAdminActions.vendorUsers.getSuccess({ users, loading: false });
					}),
					catchError((error) => {
						return of(MpAdminActions.vendorUsers.getFail(new FailState(error)));
					})
				)
			)
		)
	);

	constructor(
		private mpAdminService: MpAdminService,
		private actions: Actions,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(action, state: VendorUsersState): boolean {
		const ids = _.split(_.get(action, "params.id", "noop"), ",");
		const storeIds = _.map(state.users, (c: UserStatusResponse) => c.userId);
		const idPresent = _.every(ids, (id) => _.includes(storeIds, id));
		return idPresent && !_.has(state, "error") && !state.loading;
	}
}
